export default __webpack_public_path__ + "static/media/mana.87f6731c.svg";